<template>
  <footer class="pt-1 no-print">
    <div class="container d-md-none d-sm-block">
      <div class="row mt-4 mb-4 bordered-footer">
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <article class="links">
                <header>
                  <h5>Blog</h5>
                  <p>Informações, dicas, ajuda e novidades</p>
                </header>
              </article>
          </div>
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <a type="button" class="btn-xs btn btn-primary" title="Conheca" href="https://blog.afiliados.uol.com.br/">Conheça</a>
          </div>
      </div>

      <div class="row mt-4 mb-4 bordered-footer">
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <article class="links">
                <header>
                  <h5>Dúvidas?</h5>
                  <p>Encontre as informações que precisa aqui.</p>
                </header>
              </article>
          </div>
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <a type="button" class="btn-xs btn btn-primary" title="Conheca" href="https://afiliados.uol.com.br/ajuda.html">Ajuda</a>
          </div>
      </div>

      <div class="row mt-4 mb-4 bordered-footer">
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <article class="links">
                <header>
                  <h5>Ganhe dinheiro</h5>
                  <p>Comece agora mesmo a ganhar dinheiro com o seu site</p>
                </header>
              </article>
          </div>
          <div class="col-sm-6 col-6 d-flex align-items-center">
              <a type="button" class="btn-xs btn btn-primary" title="Conheca" href="https://afiliados.uol.com.br/app/contato">Enviar Mensagem</a>
          </div>
      </div>

      <div class="row">
          <div class="col-sm-10 col-10 d-flex align-items-center pb-4 pt-4">
              <article class="links">
                <header>
                  <h5>Fique por dentro de todas as novidades do UOL Afiliados</h5>
                </header>
              </article>
          </div>
          <div class="col-sm-2 col-2 d-flex align-items-center">
              <a href="https://www.facebook.com/UOLAfiliados/"><img class="img-fluid" src="@/assets/images/facebook.png" alt=""></a>
          </div>
      </div>
    </div>
    <!-- Footer Top Desktop -->
    <div class="container d-none d-xs-none d-md-block d-lg-block">
      <div class="row">
        <div class="col-sm-3 col-footer-first">
          <img max-width="240" class="img-fluid" src="@/assets/images/logo-header.svg" alt="" />
        </div>
           <div class="col-sm-2 mt-4 mb-4 bordered">
             <article class="links">
               <header>
                 <h5>Blog</h5>
                 <p>Informações, dicas, ajuda e novidades</p>
                 <a type="button" class="btn btn-primary" title="Conheca" href="https://blog.afiliados.uol.com.br">Conheça</a>
               </header>
             </article>
           </div>
           <div class="col-sm-2 mt-4 mb-4 bordered">
              <article class="links">
               <header>
                 <h5>Dúvidas?</h5>
                 <p>Encontre as informações que precisa aqui.</p>
                 <a type="button" class="btn btn-primary" title="Conheca" href="https://afiliados.uol.com.br/ajuda.html">Ajuda</a>
               </header>
             </article>
           </div>
           <div class="col-sm-2 mt-4 mb-4 bordered">
              <article class="links">
               <header>
                 <h5>Enviar mensagem</h5>
                 <p>Dúvidas, solicitações e assuntos gerais.</p>
                 <a type="button" class="btn btn-primary" title="Conheca" href="https://afiliados.uol.com.br/app/contato">Enviar mensagem</a>
               </header>
             </article>
           </div>
        <div class="col-sm-3 pb-4 pt-4 col-footer-last">
         <div class="row">
           <div class="col-sm-8 p-0 d-flex justify-content-end">
            <p class="text-right font-weight-bold">
              Fique por dentro de todas as novidades do UOL Afiliados
            </p>
          </div>
          <div class="col-sm-4">
            <a href="https://www.facebook.com/UOLAfiliados/"><img class="img-fluid" src="@/assets/images/facebook.png" alt=""></a>
          </div>
         </div>

        </div>
      </div>
    </div>
    <div class="copyright pt-4 pb-4">
        <p>©1996 - {{ year_copyright }} - UOL - O melhor conteúdo. Todos os direitos reservados.</p>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      year_copyright: new Date().getFullYear(),
    };
  },

};
</script>

<style lang="scss" scoped>
footer {
  background-color: $bg-dark;
  color: $text-light;
  font-family:UOLText,Helvetica,sans-serif;
}

footer article{
  display: flex;
  align-items: center;
}

footer .bordered{
  border-right: 1px solid #00479d;
}

footer .bordered-footer{
  border-bottom: 1px solid #00479d;
}

footer .col-footer-first{
  display: flex;
  align-items: center;
}
footer .col-footer-last{
  display: flex;
  align-items: center;
}

footer a, footer p{font-size: 13px;}

footer h5{font-size: 14px; font-weight: 700;}

footer .links a{
  background-color: #ff8100;
  border-radius:2px;
}

footer .btn-xs{
  background-color: #ff8100;
  border-radius:2px;
  transition: all .35ms;
}

footer .btn-xs:hover{
  background-color: #e67400;
  border-color: rgba(0,0,0,0);
}

footer .links a:hover{
    color: #fff;
    background-color: #e67400;
    border-color: rgba(0,0,0,0);
}

footer .btn{width: 100%;}

.copyright{
    background-color: #fff;
    color: #222;
}

.copyright p{
  text-align: center;
}
</style>
